angular.module 'filters'
  .filter 'formatDate', ($filter) -> (input) ->
    if input
      $filter('date') input, 'longDate'
